export const environment = {
  production: true,
  enableLogging: true,
  baseUrl: 'https://api.themaxion.com/api/v1/admin/'
};